import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import httpClient from "../../_util/api";
import { Grid, Stack, Typography, Box } from "@mui/material";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import StatCard from "../../components/StatCard";

const Dashboard = () => {
  const userdetail = useSelector((state) => state.mainSlice.userdetail);
  const { role } = userdetail;
  const [applications, setApplications] = useState({
    inprocess: 0,
    rejected: 0,
    completed: 0,
    total: 0,
  });

  const getAllApplicationByCNICNo = async () => {
    let url = '';

    if (role === 'student') {
      url = '/count/student';
    } else if (role === 'reviewer') {
      url = '/count/reviewer';
    } else if (role === 'approver') {
      url = '/count/approver';
    } else if (role === 'vendor') {
      url = '/count/vendor';
    } else {
      url = '/count/all';
    }

    try {
      const res = await httpClient.get(url);
      if (res.status === 200) {
        setApplications(res.data); // Corrected to set applications state
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getAllApplicationByCNICNo();
  }, []);

  const originalData = [
    { name: "In process", value: applications.inprocess, color: "#2f62a5" },
    { name: "Rejected", value: applications.rejected, color: "#e74c3c" },
    { name: "Completed", value: applications.completed, color: "#27ae60" },
  ];

  const data = originalData.filter(item => item.value > 0);

  return (
    <Stack spacing={3} sx={{ width: "100%", padding: 3 }}>
      <Typography variant="h6" fontWeight="bold">
        Dashboard Overview
      </Typography>
      <Box sx={{ padding: '0 16px' }}>
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} sm={6} md={3}>
            <StatCard title="Total Applications" count={applications.total} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard title="In Progress" count={applications.inprocess} color="blue" />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard title="Rejected" count={applications.rejected} color="red" />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard title="Completed" count={applications.completed} color="green" />
          </Grid>
        </Grid>
      </Box>
      <Box
        sx={{
          bgcolor: "white",
          p: 3,
          mt: 3,
          borderRadius: "12px",
          boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
        }}
      >
        <Typography variant="h6" fontWeight="bold" mb={2}>
          Applications Overview
        </Typography>

        {data.length > 0 ? (
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={data}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={100}
                label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <Typography>No data to display in chart.</Typography>
        )}
      </Box>
    </Stack>
  );
};

export default Dashboard;
